import React from 'react';
import styled from 'styled-components';

interface IStarIconProps {
  user?: 'landlord' | 'tenant';
}

const StyledSvg = styled.svg<IStarIconProps>`
  display: block;

  path {
    fill: ${({ theme, user }) => user && theme.colors[user].main};
  }
`;

const Star = ({ user = 'landlord' }: IStarIconProps): JSX.Element => (
  <StyledSvg user={user} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 0L10.472 5.26604L16 6.11567L12 10.2124L12.944 16L8 13.266L3.056 16L4 10.2124L0 6.11567L5.528 5.26604L8 0Z"
      fill="#D2007E"
    />
  </StyledSvg>
);

export default Star;
